import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-item-folder',
  styles: [`
    :host {
      display: block;
      box-sizing:border-box;
      padding:10px;
      width:33%;
    }
    .nns-item-folder-link {
      box-sizing:border-box;
      color:rgba(0,0,0,0.80);
      position:relative;
      display:block;
      transition: 0.3s;
    }
    .nns-item-folder-link:hover{
      box-shadow: 0px 1px 16px rgba(192, 205, 216, 0.8);
    }
    .nns-item-folder-layer {
      position:absolute;
      box-sizing: border-box;
      left:0;
      top:0;
      width:100%;
      height:100%;
      background:#fff;
      border: 1px solid #EAEFF1;
      border-radius: 0px 0px 4px 4px;
    }
    .nns-item-folder-layer:before {
      content: '';
      position:absolute;
      left: -1px;
      right: -1px;
      bottom: 100%;
      height: 6px;
      background: #EAEFF1;
      border-radius: 4px 0px 0px 0px;
    }
    .nns-item-folder-layer:after {
      content: '';
      position:absolute;
      right: -1px;
      bottom: calc(100% + 2px);
      width: 45px;
      height: 8px;
      background: #EAEFF1;
      border-radius: 4px;
    }
    .nns-item-folder-main {
      position:relative;
      z-index:5;
      padding: 20px;
      transition:all 0.1s ease-out;
      border-radius:2px;
      position:relative;
      box-sizing: border-box;
    }
    .nns-item-folder-link:hover {color:rgba(0,0,0,0.80);}

    .nns-item-folder-name {
      overflow:hidden;
      text-overflow:ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      font-size:14px;
      font-weight:bold;
      padding-left: 12px;
    }
    nns-item-folder .nns-item-folder-subtext {
      font-size:12px;
      color:rgba(0,0,0, 0.6);
    }

    @media only screen and (max-width: 1024px) {
      :host {width:50%;}
    }

    @media only screen and (max-width: 600px) {
      :host {width:100%;}
    }
  `, `
    :host-context(.nns-theme-night) .nns-item-folder-link {
      color:rgba(255,255,255, 0.8);
    }
    :host-context(.nns-theme-night) .nns-item-folder-layer {
      border-color: #646A6A;
      background:#292E32;
      box-shadow:4px 4px 38px rgb(19 30 32 / 66%);
    }
    :host-context(.nns-theme-night) .nns-item-folder-layer:before {
      background: #292E32;
    }
    :host-context(.nns-theme-night) .nns-item-folder-layer:after {
      background: #292E32;
    }
    :host-context(.nns-theme-night) .nns-item-folder-link:hover {
      color:#fff;
    }

    :host-context(.nns-theme-night) .nns-item-folder-link:hover {
      box-shadow: 0px 1px 16px #0C0F11;
    }

    :host-context(.nns-theme-night) .nns-item-folder-subtext {
      color:rgba(255,255,255, 0.6);
    }
    @media print {
      :host-context(.nns-theme-night) .nns-item-folder-name {
        color: #161616;
      }
    }
  `],
  template: `
  <a class="nns-item-folder-link" [routerLink]="[urlString]" title="{{item.title | unescape}}">
    <span class="nns-item-folder-layer"></span>
    <span class="nns-item-folder-main" flex layout="row" layout-align="start start">
      <nns-icon icon="folder-small"></nns-icon>
      <span class="nns-item-folder-name" [innerHTML]="item.title"></span>
    </span>
  </a>
  `,
})
export class ItemFolderComponent {
  @Input() public item;
  @Input() public share;
  urlString;

  ngOnInit() {
    const shareInstance = this.share.instance;
    if(this.item.share && this.item.share.passwordRequired) {
      const childShare = this.item.share;
      this.urlString = `/share/${childShare.id}/${childShare.securityKey}`
    } else {
      this.urlString = `/share/${shareInstance.id}/${shareInstance.securityKey}/${this.item.globalId}`;
    }
  }
}
